import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, practiceGoals } from '../data/content';
export function PracticeSection() {
  return <section aria-labelledby="practica" className="bg-brand-ivory text-brand-petrol" data-id="element-119" data-mp="2xawicxpiygit">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-120" data-mp="2ta4944gnkbmj">
        <h2 id="practica" className="font-display text-[2rem] leading-none sm:text-5xl" data-id="element-121" data-mp="3pzlgcnvaa5qc">
          Lo que vas a poder practicar
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-122" data-mp="3l0qwrjphsd56">
          Pasar de releer conceptos sueltos a trabajar con una secuencia
          organizada:
        </p>

        <ul className="mt-3 space-y-1.5 text-left" data-id="element-123" data-mp="3c75gtx1lcpu6">
          {practiceGoals.map((goal, i) => <Reveal key={goal} as="li" delay={i * 0.03} className="flex items-start gap-2 rounded-lg border-l-4 border-brand-emerald bg-white px-2.5 py-2" data-id="element-124" data-mp="clqcvd0eoasj" data-mpi={i}>
              <CheckCircle2Icon size={16} className="mt-0.5 flex-shrink-0 text-brand-emerald" aria-hidden="true" data-id="element-125" data-mp="1uph8dsdt2v74" />
              <span className="text-sm italic leading-snug" data-id="element-126" data-mp="1kws8zvvj57s5">“{goal}”.</span>
            </Reveal>)}
        </ul>

        <p className="mt-2 text-xs italic leading-snug text-brand-muted" data-id="element-127" data-mp="1pu1xn9b3hfex">
          Estos son objetivos de aprendizaje del material, no testimonios ni
          resultados garantizados.
        </p>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-128" data-mp="1gtdiucdvnb0z">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2 text-xs font-semibold text-brand-muted" data-id="element-129" data-mp="16xk6at05rhj7">
          6 tomos digitales • 5 bonos incluidos
        </p>
      </div>
    </section>;
}